module.exports = __webpack_public_path__ + "media/images/marisol-logo-854da12b761d974bd88abb59f193177d.jpg";